import template from "./confirm.html";
import {destroyController} from "./confirm.controller";

export const confirmComponent = {
	template,
	controller: destroyController,
	controllerAs: "confirm",
	bindings: {
		resolve: "<",
		close: "&",
		dismiss: "&",
		data: "<"
	}
};




// WEBPACK FOOTER //
// ./sources/utility/confirm/confirm.component.js